import { useEffect, useState } from 'react'

/**
 * «Сейчас» с точностью до минуты — общий тик всех сеток: линия текущего
 * времени, приглушение прошедших событий и отключение прошедших слотов брони
 * обязаны двигаться одновременно. Захваченный на рендере `new Date()` оставляет
 * прошедшее кликабельным до следующего ререндера.
 */
export function useNowMinute(): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60_000)
    return () => clearInterval(t)
  }, [])
  return now
}
